<script setup lang="ts">
const LANDSCAPE_FROM_TAILWIND_SM_BREAKPOINT = "(min-width: 640px)";

const { data: heroArticles } = await useHeroArticles();
const article = computed(() => heroArticles.value.landscape ?? heroArticles.value.portrait);
const portraitImage = computed(() => (heroArticles.value.portrait ?? heroArticles.value.landscape)?.mainImage?.url);
</script>

<template>
  <section
    v-if="article"
    class="bg-inverted flex flex-col h-[calc(100svh-var(--ui-header-height))] sm:h-[60vw] md:h-[50vw] lg:h-[40vw] max-h-160 relative overflow-hidden"
  >
    <WebArticlePicture
      :main-image="portraitImage"
      :media-variants="[{ media: LANDSCAPE_FROM_TAILWIND_SM_BREAKPOINT, mainImage: article.mainImage?.url }]"
      :alt="article.title"
      priority
      picture-class="absolute inset-0 size-full"
      img-class="size-full object-cover"
    />
    <AppSection
      class="relative grow flex flex-col"
      :ui="{
        base: 'px-4 pt-12 pb-5 sm:p-10 sm:pb-5',
      }"
    >
      <div class="flex flex-col">
        <div class="text-6xl sm:text-8xl/[1.2] leading-tight mb-4">
          <h1 class="font-semibold">
            {{ article.title }}&nbsp;<span class="md:block font-normal">{{ article.content }}</span>
          </h1>
        </div>
        <div class="flex gap-x-4 gap-y-2 flex-wrap">
          <UButton :to="$localePath('/login')" variant="solid" color="secondary" size="md">
            {{ $t("ui.login") }}
          </UButton>
          <UButton :to="$localePath('/register')" variant="link" class="lg:hidden in-inverted:hover:not-disabled:text-blue-300">
            {{ $t("register.title") }}
          </UButton>
        </div>
      </div>
      <div class="mt-auto flex justify-center sm:justify-start">
        <UButton
          square
          variant="soft"
          color="neutral"
          to="#content"
          :aria-label="$t('welcome.hero.scrollDown')"
          class="p-2.5 rounded-full hover:-translate-y-1 transition-transform"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M8.86198 3.17188L8.86198 13.9518L3.90365 8.99349L2.66406 10.2552L9.7474 17.3385L16.8307 10.2552L15.5911 8.99349L10.6328 13.9518L10.6328 3.17188L8.86198 3.17188Z"
              fill="currentColor"
            />
          </svg>
        </UButton>
      </div>
    </AppSection>
  </section>
</template>
